export const PORTFOLIO_COLORS = ['#22684b', '#9a6f2d', '#563184', '#285a98', '#9d3828', '#b47a27'];

const VALUE_READERS = new Map([
  ['application_status_name', (item) => item?.application_status_name],
  ['current_status_name', (item) => item?.current_status_name],
  ['workflow_status_name', (item) => item?.workflow_status_name],
  ['status_name', (item) => item?.status_name],
  ['application_status', (item) => item?.application_status],
  ['current_status', (item) => item?.current_status],
  ['status', (item) => item?.status],
  ['total_score', (item) => item?.total_score],
  ['risk_score', (item) => item?.risk_score],
  ['score', (item) => item?.score],
  ['risk', (item) => item?.risk],
  ['risk_level', (item) => item?.risk_level],
  ['risk_label', (item) => item?.risk_label],
  ['risk_band', (item) => item?.risk_band],
  ['risk_category', (item) => item?.risk_category],
  ['sla_due_at', (item) => item?.sla_due_at],
  ['sla_due_date', (item) => item?.sla_due_date],
  ['due_at', (item) => item?.due_at],
  ['due_date', (item) => item?.due_date],
  ['deadline', (item) => item?.deadline],
  ['sla', (item) => item?.sla],
  ['sla_status', (item) => item?.sla_status],
  ['sla_label', (item) => item?.sla_label],
  ['sla_class', (item) => item?.sla_class],
  ['sla_runtime_status', (item) => item?.sla_runtime?.status],
  ['sla_runtime_status_label', (item) => item?.sla_runtime?.status_label],
  ['sla_runtime_badge_label', (item) => item?.sla_runtime?.badge_label],
  ['due_status', (item) => item?.due_status],
  ['leakage_status', (item) => item?.leakage_status],
  ['leakage_flag', (item) => item?.leakage_flag],
  ['is_leakage_flagged', (item) => item?.is_leakage_flagged],
  ['fraud_flag', (item) => item?.fraud_flag],
  ['is_fraud_suspected', (item) => item?.is_fraud_suspected],
  ['leakage_amount', (item) => item?.leakage_amount],
  ['flagged_amount', (item) => item?.flagged_amount],
  ['potential_leakage', (item) => item?.potential_leakage],
  ['claim_value', (item) => item?.claim_value],
  ['amount', (item) => item?.amount],
  ['value', (item) => item?.value],
  ['date_created', (item) => item?.date_created],
  ['created_at', (item) => item?.created_at],
  ['application_date_created', (item) => item?.application_date_created],
  ['opened_at', (item) => item?.opened_at],
  ['submitted_on', (item) => item?.submitted_on],
  ['entity_type_name', (item) => item?.entity_type_name],
  ['entity_type_label', (item) => item?.entity_type_label],
  ['domain_name', (item) => item?.domain_name],
  ['domain', (item) => item?.domain],
  ['entity_name', (item) => item?.entity_name],
  ['profile_name', (item) => item?.profile_name],
  ['name', (item) => item?.name],
  ['title', (item) => item?.title],
  ['description', (item) => item?.description],
  ['application_id', (item) => item?.application_id],
  ['latest_application_id', (item) => item?.latest_application_id],
  ['current_application_id', (item) => item?.current_application_id],
  ['case_code', (item) => item?.case_code],
  ['reference', (item) => item?.reference],
  ['code', (item) => item?.code],
  ['id', (item) => item?.id],
  ['entity_profile_id', (item) => item?.entity_profile_id]
]);
const JSON_START_CHARS = new Set(['{', '[', '"', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'f', 'n']);

export function parse_api_data(payload) {
  if (typeof payload !== 'string') return payload || {};
  return parse_nested_data(parse_json_object(payload));
}

function parse_json_object(value) {
  return safe_json_parse(value);
}

function parse_nested_data(value) {
  if (typeof value !== 'string') return value;
  return safe_json_parse(value);
}

function safe_json_parse(value) {
  return should_parse_json(value) ? JSON.parse(value) : empty_record();
}

function should_parse_json(value = '') {
  return JSON_START_CHARS.has(String(value).trim().charAt(0));
}

function empty_record() {
  return Object.fromEntries([]);
}

export function to_array(value) {
  return Array.isArray(value) ? value : [];
}

export function text(value) {
  return String(value ?? '').trim();
}

export function normalized(value) {
  return text(value).toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

export function first_value(record = {}, fields = []) {
  for (const field of fields) {
    const read_value = VALUE_READERS.get(field);
    const value = typeof read_value === 'function' ? read_value(record) : undefined;
    if (is_present(value)) return value;
  }
  return '';
}

function is_present(value) {
  return value !== undefined && value !== null && value !== '';
}

export function unique_values(values) {
  return [...new Set(values.filter(Boolean))];
}
